import { createFileRoute } from "@tanstack/react-router";
import { RepositoryPage } from "@/features/repository/RepositoryPage";
import { repositoryQuery } from "@/lib/api/queries";

export const Route = createFileRoute("/w/$workspace/p/$project/repository")({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(repositoryQuery(params.workspace, params.project)),
  component: () => {
    const { workspace, project } = Route.useParams();
    return <RepositoryPage workspace={workspace} project={project} />;
  },
});
